/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Musicology17Inputs */

const en__field__enum_primarystudyinterest_study_musicology17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Musicology17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musicology`)
};

const de__field__enum_primarystudyinterest_study_musicology17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Musicology17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musikwissenschaft`)
};

/**
* | output |
* | --- |
* | "Musicology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Musicology17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_musicology17 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Musicology17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Musicology17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_musicology17(inputs)
	return de__field__enum_primarystudyinterest_study_musicology17(inputs)
});
export { _field__enum_primarystudyinterest_study_musicology17 as "_field__enum_primaryStudyInterest_STUDY_MUSICOLOGY" }